export var WatchType;
(function (WatchType) {
    WatchType[WatchType["ORDER"] = 1] = "ORDER";
    WatchType[WatchType["PART"] = 2] = "PART";
})(WatchType || (WatchType = {}));
//# sourceMappingURL=watch-type.js.map